import { useState, useCallback } from 'react';
import AppModal from '../components/common/AppModal';

/**
 * useAppModal — hook per mostrare modali in-app al posto di alert/confirm.
 *
 * const { modal, showModal } = useAppModal();
 *
 * showModal({ type, title, message, onConfirm, confirmLabel, cancelLabel })
 * Tipi: 'success' | 'error' | 'info' | 'confirm' | 'warning'
 *
 * Aggiungi {modal} nel JSX del componente.
 */
export function useAppModal() {
  const [config, setConfig] = useState(null);

  const closeModal = useCallback(() => setConfig(null), []);

  const showModal = useCallback((cfg) => setConfig(cfg), []);

  const modal = config ? (
    <AppModal
      type={config.type || 'info'}
      title={config.title}
      message={config.message}
      confirmLabel={config.confirmLabel}
      cancelLabel={config.cancelLabel}
      onClose={closeModal}
      onConfirm={config.onConfirm ? () => { config.onConfirm(); closeModal(); } : undefined}
    />
  ) : null;

  return { modal, showModal };
}
